export const whiteListHeaders = [
  { text: 'Mã số', value: 'id', align: 'start', sortable: true },
  { text: 'Mã nhân viên', value: 'employeeCode', sortable: true },
  { text: 'Họ và tên', value: 'employeeName', sortable: true },
  { text: 'Khu vực', value: 'location', sortable: true },
  { text: 'Địa chỉ IP cho phép', value: 'allowedIp', sortable: false },
  { text: 'Hiệu lực từ', value: 'validFrom', sortable: true },
  { text: 'Hiệu lực đến', value: 'validTo', sortable: true },
  { text: 'Thao tác', value: 'actions', sortable: false } // nếu có nút sửa/xóa
];